
<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  setup() {
    // element-plus页面重置时报错 ResizeObserver loop completed with undelivered notifications.
    // 百度的解决方案
    const debounce = (callback, delay) => {
      let tid
      return function (...args) {
        const ctx = self
        tid && clearTimeout(tid)
        tid = setTimeout(() => {
          callback.apply(ctx, args)
        }, delay)
      }
    }

    const _ = window.ResizeObserver
    window.ResizeObserver = class ResizeObserver extends _ {
      constructor(callback) {
        callback = debounce(callback, 20)
        super(callback)
      }
    }
  },
}
</script>
